import Company from './Company';

type UserRole = 'admin' | 'auditor' | 'certifier' | 'customer';

interface User {
    id: number;
    name: string;
    surname: string;
    username: string;
    type: UserRole;
    enabled: boolean;
    phoneOffice?: string;
    phoneMobile?: string;
    email: string;
    countryId: number;
    address?: string;
    postalCode?: string;
    city?: string;
    note?: string;
    state?: string;
    privacy: boolean;
    newsletter: boolean;
    company: Company | null;
    companies: Company[];
    enabledCompanies: Company[];
    users: User[];
    canDelete?: boolean;
    allowedStates: string[];
    allowedStateChanges: [];
}

const EmptyUser: User = {
    id: 0,
    name: '',
    surname: '',
    username: '',
    type: 'customer',
    enabled: true,
    email: '',
    countryId: 0,
    privacy: false,
    newsletter: false,
    company: null,
    companies: [],
    enabledCompanies: [],
    users: [],
    allowedStates: [],
    allowedStateChanges: []
};

export { EmptyUser };
export type { UserRole };

export default User;
